import React from "react";
import { X } from "lucide-react";
import FormPreview from "./FormPreview";

export default function PreviewModal({ open, form, onClose }) {
  if (!open || !form) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 py-8">
      <div className="relative max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-2xl bg-white p-8 shadow-xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 rounded p-1 text-gray-400 hover:bg-gray-100"
        >
          <X className="h-5 w-5" />
        </button>
        <FormPreview form={form} />
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg bg-[#EAF524] px-8 py-2.5 text-sm font-semibold text-black"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
